import { pList } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { rOyakKiraBilgileriUstBilgiKvtDetay } from '../../../../api/models/rOyakKiraBilgileriUstBilgiKvtDetay';
import rList from '../../../../api/models/rList';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIKVTDETAY,
    new Api.Bilgi.OyakKiraBilgileriUstBilgiKvtDetay().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rList<rOyakKiraBilgileriUstBilgiKvtDetay> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOyakKiraBilgileriUstBilgiKvtDetay[]> =>
  ActionFunctions.action_async_complete_api<rOyakKiraBilgileriUstBilgiKvtDetay[]>(
    ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIKVTDETAY,
    data?.Values,
    error
  );
